import React from 'react'
import NotificationsComponent from '@components/pages/Notifications/Notifications.component'

function NotificationsPage(): React.ReactElement {
  return <NotificationsComponent />
}

export default NotificationsPage
